const inr = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const whole = new Intl.NumberFormat("en-IN");

const missing = (value) => value === null || value === undefined || Number.isNaN(Number(value));

export const rupees = (value) => (missing(value) ? "--" : `₹ ${inr.format(Number(value))}`);
export const pct = (value) => (missing(value) ? "--" : `${Number(value).toFixed(1)} %`);
export const minutes = (value) => (missing(value) ? "--" : `${Math.round(Number(value))} min`);
export const minutesPerKm = (value) => (missing(value) ? "--" : `${Number(value).toFixed(1)} min/km`);
export const qty = (value) => (missing(value) ? "--" : String(Number(value)));
export const count = (value) => (missing(value) ? "--" : whole.format(Number(value)));

export const changeLabel = (tile) => {
  if (!tile || tile.change_pct === null || tile.change_pct === undefined) {
    return { text: "no previous range", direction: "flat" };
  }
  const sign = tile.change_pct > 0 ? "+" : "";
  const direction = tile.change_pct > 0 ? "up" : tile.change_pct < 0 ? "down" : "flat";
  return { text: `${sign}${Number(tile.change_pct).toFixed(1)}% vs previous`, direction };
};

const wholeInr = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const rupeesWhole = (value) => (missing(value) ? "--" : `₹ ${wholeInr.format(Math.round(Number(value)))}`);

const parts = (iso) => {
  const [year, month, day] = String(iso).split("-").map(Number);
  return { year, month: MONTHS[month - 1], day };
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const { year, month, day } = parts(iso);
  return `${day} ${month} ${year}`;
};

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const fmtDateWithWeekday = (iso) => {
  if (!iso) return "";
  const [year, month, day] = String(iso).split("-").map(Number);
  const dt = new Date(Date.UTC(year, month - 1, day));
  const weekday = WEEKDAYS[dt.getUTCDay()];
  return `${weekday}, ${day} ${MONTHS[month - 1]} ${year}`;
};

export const rangeLabel = (range) => {
  if (!range || !range.from || !range.to) return "";
  const from = parts(range.from);
  const to = parts(range.to);
  if (from.year === to.year && from.month === to.month) return `${from.day}–${to.day} ${to.month} ${to.year}`;
  const fromText = from.year === to.year ? `${from.day} ${from.month}` : `${from.day} ${from.month} ${from.year}`;
  return `${fromText} – ${to.day} ${to.month} ${to.year}`;
};

export const deltaTone = (betterWhen, changePct) => {
  if (betterWhen === "none" || missing(changePct) || Number(changePct) === 0) return "flat";
  const up = Number(changePct) > 0;
  return (betterWhen === "up") === up ? "good" : "bad";
};

const LABELS = {
  DELIVERY: "Delivery",
  SELF_PICKUP: "Self pickup",
  EXPRESS: "Express",
  SCHEDULED: "Scheduled",
  COD: "Cash on delivery",
  ONLINE: "Online",
  OTHER: "Wallet / other",
};

export const labelFor = (key) => LABELS[key] || key;

export const AMOUNT_LABELS = {
  food: "Food amount",
  delivery: "Delivery charges",
  store: "Store charges",
  franchise: "Surge",
  gst: "GST",
  total: "Total paid",
};

export const amountLabel = (key) => AMOUNT_LABELS[key] || AMOUNT_LABELS.food;
